import React from "react";

export default React.createContext<{
  glParent: any;
  glSurface: any;
  glSizable: any;
}>(null as any);
